import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'
import { QueryErrorResetBoundary } from '@tanstack/react-query'
import { RouteErrorDisplay } from '@/components/RouteErrorDisplay'
import { requireAnyPermission } from '@/lib/auth/route-guards'
import type { RouterAuthContext } from '@/lib/auth/router-context'

export const Route = createFileRoute('/app/billing')({
  // Permission guard: requires any billing view permission
  beforeLoad: async ({ context, location }) => {
    await requireAnyPermission(
      context as RouterAuthContext,
      ['billing:view-own', 'billing:view-all'],
      { currentPath: location.pathname }
    )
  },

  component: lazyRouteComponent(() => import('./-billing')),
  errorComponent: ({ error }) => (
    <QueryErrorResetBoundary>
      {({ reset }) => <RouteErrorDisplay error={error} reset={reset} />}
    </QueryErrorResetBoundary>
  ),
})
